import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const allIndustryList = createAsyncThunk(
    "allIndustryList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/industry/industry-list?page=${body.page}&search=${body.search}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const IndustrySlice = createSlice({
    name: "IndustrySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(allIndustryList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(allIndustryList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(allIndustryList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default IndustrySlice.reducer;
